var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFondoPortada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#796254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.41 924.686C1505.72 919.753 1483.87 897.937 1478.93 863.403C1476.74 848.055 1478.71 833.036 1481.79 818.017C1493.2 763.531 1521.53 718.035 1557.54 676.925C1567.86 665.194 1581.69 661.138 1597.17 663.769C1603.1 664.756 1608.92 666.4 1614.41 668.593C1633.29 676.157 1648 688.984 1660.08 705.209C1678.96 730.643 1698.17 755.748 1721.56 777.345C1725.95 781.401 1729.68 786.225 1733.08 791.048C1746.92 810.782 1746.26 831.392 1731.22 850.138C1728.25 853.866 1724.85 857.483 1721.34 860.663C1709.92 871.187 1696.75 879.08 1683.13 886.316C1654.15 901.554 1623.19 911.421 1592.01 920.959C1578.18 925.234 1564.24 927.098 1549.96 925.344C1546.78 925.125 1543.49 925.015 1540.3 924.576L1540.41 924.686ZM1519.33 862.526C1520.87 889.057 1538.22 907.803 1564.67 912.627C1576.42 914.819 1588.06 914.271 1599.59 911.531C1621.54 906.159 1641.52 896.621 1659.42 882.917C1683.79 864.28 1693.12 839.395 1689.5 809.466C1685.88 779.537 1673.91 752.678 1656.46 728.56C1645.04 712.664 1631.64 698.193 1619.02 683.173C1617.37 681.2 1615.29 679.446 1613.2 677.802C1602 668.812 1590.15 668.264 1579.06 677.363C1573.35 681.967 1568.3 687.887 1564.46 694.136C1545.46 724.504 1533.39 757.721 1526.36 792.693C1523.73 805.41 1522.08 818.346 1519.99 830.953C1519.66 841.587 1518.68 852.002 1519.22 862.417L1519.33 862.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.15 830.723V829.285L1584.47 848.523H1580.8L1571.17 829.285V830.636L1570.47 848.523H1565.79L1566.89 821.972H1572.49L1581.96 841.08C1582.26 841.647 1582.46 842.256 1582.61 842.69C1582.76 842.256 1583.01 841.643 1583.31 841.08L1592.78 821.972H1598.43L1599.53 848.523H1594.8L1594.14 830.723H1594.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.91 848.526V821.976H1630.67V825.72H1614.55V833.337H1628.6V837.081H1614.55V844.786H1631.12V848.53H1609.91L1609.91 848.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.61 848.526L1635.96 821.976H1641.15L1650.12 841.255C1650.57 842.302 1650.98 843.432 1651.28 844.52C1651.64 843.432 1652.04 842.302 1652.44 841.255L1661.61 821.976H1666.65L1653.95 848.526H1648.61H1648.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.84 848.526V821.976H1677.48V848.526H1672.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.51 816.622L1549.46 819.712L1551.22 818.144L1545.03 813.445H1541.95L1535.8 818.144L1537.57 819.712L1543.51 816.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.59 821.976H1540.39L1527.59 848.526H1532.58L1543.46 824.803L1554.4 848.526H1559.38L1546.59 821.976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoPortada);
export default __webpack_public_path__ + "static/media/fondo_portada.092f941b86b2350247cbd8ddaf7f6ab3.svg";
export { ForwardRef as ReactComponent };